<template>
	<div class="order-footer">
		<div class="order-data-bar">
			<div class="order-data-col">
				<h5>
					<img src="/static/img/icons/map.svg" alt="" height="17">
					{{ dispatchName }}
				</h5>
				<p v-if="!!warehouseAddress">
					{{ warehouseAddress }}
				</p>
				<p v-else>
					{{ customer.fullName }} {{ customer.documentType }}: {{ customer.documentNumber }}
					Teléfono: {{ customer.phone }} Dirección: {{ customer.address }}
				</p>
			</div>
			<div class="order-data-col" v-if="flagBill">
				<h5>Solicitud de Factura:</h5>
				<p>
					RUC: {{ billing.documentNumber }} Razón Social: {{ billing.rzSocial }}
					Domicilio Fiscal: {{ billing.address }}
				</p>
			</div>
			<div class="order-data-col">
				<h5>Método de Pago</h5>
				<p v-if="paymentMethod">
					{{ paymentMethod }}
				</p>
				<p v-else>
					Tarjeta de Crédito o Débito
				</p>
			</div>
		</div>
		<order-payment-data
			:account-name="accountName"
			:account-number="accountNumber"
			:description="description"
			:gateway-transaction-id="gatewayTransactionId"
			:logo-bank="logoBank"
			:card-number="cardNumber"
			:succes="success"
		></order-payment-data>
	</div>
</template>

<script>
	import orderPaymentData from '@/components/order/order-payment-data';

	export default {
		name: 'order-footer',
		components: {
			orderPaymentData,
		},
		props: {
			accountName: String,
			accountNumber: [Number, String],
			billing: {
				default: () => {},
				type: Object,
			},
			cardNumber: String,
			customer: {
				default: () => {},
				type: Object,
			},
			description: String,
			dispatchName: String,
			flagBill: {
				default: false,
				type: Boolean,
			},
			gatewayTransactionId: [Number, String],
			logoBank: String,
			paymentMethod: String,
			success: {
				default: false,
				type: Boolean,
			},
			warehouseAddress: String,
		},
	};
</script>

<style lang="scss" scoped>
	.order-footer {
		border-bottom: 1px solid color(borderThum);
		margin-bottom: 55px;
		padding-bottom: 55px;
	}

	.order-data-bar {
		align-items: flex-start;
		border-bottom: 1px solid color(borderThum);
		border-top: 1px solid color(borderThum);
		display: flex;
		justify-content: space-between;
		margin: 39px auto;
		padding: 35px 22px;
	}

	.order-data-col {
		font-size: size(medium) !important;
		max-width: 35%;
	}

	h5, img, p {
		font-size: size(medium) !important;
		margin: 0px;
		vertical-align: middle;
	}
</style>


// WEBPACK FOOTER //
// order-footer.vue?bea735e2